import PageWrapper from "../../components/PageWrapper";
import {  Button, Row, Col ,Container } from "react-bootstrap";
import PricingCard from "../../components/PricingCard";
import SectionHeading from "../../components/SectionHeading";



const Plans = () => {

    // Pricing Plans
const pricingPlans = [
  {
    name: "Clinic",
    subtitle: "For single-location practices",
    features: [
      "Appointments, e-Rx, basic lab workflows",
      "1 location, up to X doctors, Y staff seats",
      "Standard support (IST business hours)",
    ],
    link: "/plan/clinic",
  },
  {
    name: "Multi-Clinic",
    subtitle: "For growing groups",
    features: [
      "Everything in Clinic + multi-location + advanced reports",
      "Up to N locations, X doctors/location",
      "Priority support · Custom roles/permissions",
    ],
    link: "/plan/multiclinic",
  },
  {
    name: "Hospital Network",
    subtitle: "For large orgs",
    features: [
      "Everything in Multi-Clinic + multi-lab, SSO/SAML, VAPT reports",
      "Unlimited locations & labs · Single-tenant/VPC options",
      "Dedicated success manager",
    ],
    link: "/plan/network",
  },
];

  return (
    <PageWrapper
      title="Plans"
    //   bgImage={bannerImg}
    >
           {/* PRICING */}
      <section id="pricing" className="py-5 mx-4">
        <SectionHeading title="Pricing" />

        <Container>
          <Row className="g-4 text-center">
            {pricingPlans.map((plan, i) => (
              <Col md={4} key={i}>
                <PricingCard
                  name={plan.name}
                  subtitle={plan.subtitle}
                  features={plan.features}
                  link={plan.link}
                />
              </Col>
            ))}
          </Row>

          {/* Bottom Buttons */}
          <div className="d-flex justify-content-center gap-3 flex-wrap mt-4">
            <Button
              size="md"
              className="px-4 py-2 landing-primary-class"
            >
              Compare Plans
            </Button>

            <Button
              size="md"
              className="px-4 py-2 landing-primary-class"
            >
              Request Custom Quote
            </Button>
          </div>

        </Container>
      </section>



    </PageWrapper>
  );
};

export default Plans;
